
    import {
        IonContent,
        IonHeader,
        IonTitle,
        IonToolbar,
        IonButtons,
        IonButton,
        modalController
    } from "@ionic/vue";
    import { defineComponent } from "vue";
    import { useI18n }        from 'vue-i18n';
    export default defineComponent({
        name: "DeviceModal",
        components: {  },
        props: ['device'],
        data()
        {
            return {
                ws: null
            };
        },
        setup() {
            const { t } = useI18n({
                inheritLocale: true,
                useScope: 'global'
            });
            return { IonContent,
                IonHeader,
                IonTitle,
                IonToolbar,
                IonButtons,
                IonButton,
                modalController,
                t
            };
        },
        mounted() {
            const self = this;
            setTimeout(() => {
                //@ts-ignore
                const terminal = new window.Terminal({
                    allowProposedApi: true,
                    cursorBlink: true, // Enable blinking cursor
                    theme: {
                        background: '#1e1e1e', // Terminal background color
                        foreground: '#ffffff'  // Text color
                    },
                    rows: 24,
                    cols: 80,
                    convertEol: true,
                    scrollback: 1000
                });
                //@ts-ignore
                const fitAddon = new window.FitAddon.FitAddon();
                terminal.loadAddon(fitAddon);
                // terminal.onResize(function (evt) {
                //     const terminal_size = {
                //         Width: evt.cols,
                //         Height: evt.rows,
                //     };
                //     console.log(terminal_size);
                //     terminal.writeln(`\x1b[8;${evt.rows};${evt.cols}t\n`);
                // });
                terminal.onRender(function (evt) {
                    fitAddon.fit();
                });
                terminal.open(this.$refs.terminalRef, true);
                setTimeout(() => fitAddon.fit(), 500);
                const xterm_resize_ob = new ResizeObserver(function (entries) {
                    try {
                        console.log('xterm has been resized.');
                        fitAddon && fitAddon.fit();
                    } catch (err) {
                        console.log(err);
                    }
                });
                //@ts-ignore
                xterm_resize_ob.observe(this.$refs.terminalRef);
                // WebSocket connection
                //@ts-ignore
                this.ws = new WebSocket('wss://' + window.location.hostname + ':4001/terminal/' + this.device.serial_number);
                // this.ws = new WebSocket('wss://demo.app.lexoh.com:4001/terminal/' + this.device.serial_number);
                //@ts-ignore
                this.ws.binaryType = 'blob';
                // WebSocket events
                //@ts-ignore
                this.ws.onopen = () => {
                    terminal.writeln('Connected to WebSocket server.');
                    //@ts-ignore
                    this.ws.send('{"Action": "Authenticate", "Token": "' + localStorage.getItem('token') + '"}');
                    fitAddon.fit();
                };
                //@ts-ignore
                this.ws.onmessage = (event) => {
                    const message = event.data;
                    terminal.write(message);
                };
                //@ts-ignore
                this.ws.onclose = () => {
                    terminal.writeln('Disconnected from WebSocket server.');
                };
                //@ts-ignore
                this.ws.onerror = (error) => {
                    console.error('WebSocket error:', error);
                    //@ts-ignore
                    terminal.writeln('WebSocket error: ' + error.message);
                };
                // Handle terminal input and send it to the server
                terminal.onData((data) => {
                    //@ts-ignore
                    this.ws.send(data);
                });
            }, 10);
        },
        beforeUnmount() {
            debugger;
            //@ts-ignore
            this.ws.close();
        },
        methods: {
            closeModal()
            {
                debugger;
                //@ts-ignore
                this.ws.close();
                modalController.dismiss();
            }
        },
        computed: {
            darkMode() {
                return document.body.classList.contains('dark');
            }
        }
    });
